import React from 'react';
import cx from 'classnames';

import initSvg from 'ha/utils/initSvg';

export const getRotation = (rotation: number) =>
  rotation > 0 ? `rotate-${rotation}` : `rotate-n${Math.abs(rotation)}`;

interface Props {
  name: string;
  className?: string;
  title?: string;
  rotate?: number;
}

class SvgIcon extends React.Component<Props> {
  static spriteInitialized = false;

  componentDidMount() {
    if (SvgIcon.spriteInitialized) {
      return;
    }

    SvgIcon.spriteInitialized = true;

    initSvg();
  }

  render() {
    const { name, className, title, rotate } = this.props;

    return (
      <svg
        className={cx(
          `svgicon__${name}`,
          className,
          rotate && getRotation(rotate),
        )}
      >
        {title && <title>{title}</title>}
        <use xlinkHref={`#icon-${name}`} />
      </svg>
    );
  }
}

export default SvgIcon;
